<template functional>
  <div class="calendar-table__cell"
       :class="{'active':props.active}"
       v-on="listeners">
    <div class="inner">
      <div class="date">{{ props.date }}</div>
      <div class="info">
        <div class="info__row">
          <div class="info__item --income"
               v-if="props.transactionsData && props.transactionsData.incomes">
            {{ $options.roundTo99(props.transactionsData.incomes) }}
          </div>
          <div class="info__item --expense"
               v-if="props.transactionsData && props.transactionsData.expenses">
            {{ $options.roundTo99(props.transactionsData.expenses) }}
          </div>
          <div class="info__item --transfer"
               v-if="props.transactionsData && props.transactionsData.transfers">
            {{ $options.roundTo99(props.transactionsData.transfers) }}
          </div>
        </div>
        <div class="info__row">
          <div class="info__item info__item--plan --income"
               v-if="props.transactionsData && props.transactionsData.incomes_planned">
            {{ $options.roundTo99(props.transactionsData.incomes_planned) }}
          </div>
          <div class="info__item info__item--plan --expense"
               v-if="props.transactionsData && props.transactionsData.expenses_planned">
            {{ $options.roundTo99(props.transactionsData.expenses_planned) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CalendarTableCell",
  props: {
    date: {
      type: Number
    },
    active: {
      type: Boolean
    },
    transactionsData: {
      type: Object
    }
  },
  roundTo99(num) {
    return num >= 100 ? 99 : num;
  }
}
</script>

<style lang="scss" scoped>
.calendar-table__cell {
  @apply text-center;
  padding: 2px;
  height: 89px;

  .inner {
    @apply text-sm text-text h-full rounded transition duration-200 cursor-pointer
    flex flex-col items-center;
    padding-top: 12px;
  }

  .date {
    height: 20px;
    line-height: 20px;
  }

  .info {
    @apply flex flex-col mx-auto;
    max-width: 61px;

    &__row {
      @apply flex col-gap-2;
    }

    &__item {
      @apply text-2xs rounded-full text-white
      flex items-center justify-center;
      height: 17px;
      width: 17px;
      line-height: 16px;

      &:not(.info__item--plan) {
        @apply mb-2;
        &.--expense {
          @apply bg-red;
        }

        &.--income {
          @apply bg-green;
        }

        &.--transfer {
          @apply bg-yellow;
        }
      }

      &--plan {
        @apply text-text border bg-white;
        &.--expense {
          @apply border border-red;
        }

        &.--income {
          @apply border-green;
        }
      }
    }
  }

  &:hover,
  &.active {
    .inner {
      @apply bg-text-label text-white;
    }
  }
}
</style>